<app-power-bi reportId="VEHICLE_DETAILS" height="800" [filters]="powerBiFilters" *ngIf="powerBiFilters"></app-power-bi>

